import type { TemplateConfigInput } from '@server/trading-templates/schemas/input.schema';
import type { TradingStrategy } from '@client/widgets/trading-form/trading-form.types';

type StrategyTemplateConfig = Extract<TemplateConfigInput, { type: 'strategy' }>;
type StrategyTemplateValue = StrategyTemplateConfig['value'];

// Strategy templates are stored as full strategy snapshots, so persistence no longer needs
// to split signal-block refs from inline rows.
export const formStrategyToTemplateValue = (
  strategy: TradingStrategy
): StrategyTemplateValue => structuredClone(strategy);

// Restoring/applying a strategy template should produce a detached strategy config with no
// relationship to the source template after the copy is made.
export const templateValueToFormStrategy = (
  value: StrategyTemplateValue
): TradingStrategy => structuredClone(value);
